import script from "./MyInputList.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyInputList.vue?vue&type=script&lang=ts&setup=true"

import "./MyInputList.vue?vue&type=style&index=0&id=1a466d35&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a466d35"]])

export default __exports__